import type {
  IParsedSegment,
  IParsedSingleSegment,
  ISegment,
  ISingleSegment,
} from '@/Interfaces/Segments/Segment.interface';
import { pluck } from '../object';

export const processApiSegmentsResponse = (segments: ISegment[]): IParsedSegment[] => {
  if (!segments?.length) return [];

  return segments.map(segment => ({
    ...pluck(segment, ['id', 'segmentId', 'name', 'active', 'dateCreated', 'userCountByRegion']),
    advertiser: { value: segment.advertiserId, label: segment.advertiserName },
    action: segment.id,
  }));
};

export const processSingleSegmentResponse = (segment: ISingleSegment): IParsedSingleSegment => {
  return {
    ...pluck(segment, ['id', 'segmentId', 'name', 'active', 'creatives', 'segmentUrl']),
    advertiser: { value: segment.advertiserId, label: segment.advertiserName },
  };
};
